import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['widget']
  static values = {
    'sitekey': String,
    'theme': String
  }

  connect () {
    this.renderTurnstile()
  }

  renderTurnstile () {
    if (typeof turnstile === 'undefined') {
      console.warn('Turnstile script not loaded yet. Retrying...')
      setTimeout(this.renderTurnstile.bind(this), 100)
      return
    }

    this.widgetTargets.forEach((el) => {
      if (!el.dataset.turnstileInitialized) {
        turnstile.render(el, {
          sitekey: this.sitekeyValue,
          theme: this.themeValue || 'light',
        })
        el.dataset.turnstileInitialized = 'true'
      }
    })
  }
}
